
import { Client } from "@/models/Client";
import { WorkoutType } from "@/models/WorkoutType";
import { FormData } from "@/components/clients/utils/clientFormSchema";
import { CreateClientData, SubscriptionFormData } from "./types";

export const getDefaultSubscriptions = (workoutTypes: WorkoutType[]): SubscriptionFormData[] => {
  // Start with empty array - user will add subscriptions manually
  return [];
};

export const getInitialSubscriptions = (
  initialData: Client | undefined,
  workoutTypes: WorkoutType[]
): SubscriptionFormData[] => {
  if (!initialData || !initialData.subscriptions || initialData.subscriptions.length === 0) {
    return [];
  }
  
  // Only return active subscriptions that exist in the client data
  return initialData.subscriptions
    .filter(sub => sub.isActive)
    .map(sub => ({
      workoutTypeId: sub.workoutTypeId,
      sessionsPerMonth: sub.sessionsPerMonth.toString(),
      totalPrice: sub.price.toString()
    }));
};

export const createClientData = (data: FormData, includeSubscriptions: boolean = true): CreateClientData => {
  const baseData = {
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    phone: data.phone,
    address: data.address,
    notes: data.notes,
    birthDate: data.birthDate,
    gender: data.gender,
    weightKg: data.weightKg,
    heightCm: data.heightCm,
  };

  if (includeSubscriptions && data.subscriptions) {
    // Only include subscriptions that have been explicitly added (non-empty values)
    const activeSubscriptions = data.subscriptions.filter(
      sub => sub.sessionsPerMonth && sub.sessionsPerMonth !== "0" && sub.workoutTypeId
    );
    
    return {
      ...baseData,
      subscriptions: activeSubscriptions.map(sub => ({
        workoutTypeId: sub.workoutTypeId,
        sessionsPerMonth: Number(sub.sessionsPerMonth),
        price: Number(sub.totalPrice)
      }))
    };
  }

  return baseData;
};
